import "./index.scss";
import React from "react";

export const PageHeader = ({children}) => (
  <div className="pageHeader">{children}</div>
);
